import { render, staticRenderFns } from "./px-button.vue?vue&type=template&id=7f37f6dd&scoped=true&"
import script from "./px-button.vue?vue&type=script&lang=ts&"
export * from "./px-button.vue?vue&type=script&lang=ts&"
import style0 from "./px-button.vue?vue&type=style&index=0&id=7f37f6dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f37f6dd",
  null
  
)

export default component.exports